/* =========================================================
  ____    ___    ____   _   __       __                
 |  _ |  / _ \  |  _ \ | | |   \    |   \  ___  __ __  
 |  __| | |_| | |  __/ | | | |) | o | |) |/ -_) \ V /  
 |_|\_\ |_| |_| |_|    |_| |___/    |___/ \___|  \_/  o o o  

========================================================== */

import React, { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import Box from "@mui/material/Box";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { useTranslation } from "react-i18next";
import { APP_STATE } from "services/Define";
import { FetchData } from "services/Request";
import * as Func from "services/Function";
import { useSelector } from "react-redux";

// Anaytics dashboard components
import SalesByCountry from "layouts/dashboards/analytics/components/SalesByCountry";

// Data
import reportsBarChartData from "layouts/dashboards/analytics/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboards/analytics/data/reportsLineChartData";

// Images
import Navbar from "examples/Navbars/NavBar";

function Dashboard() {
  const mod = "dashboard";
  const { sales, tasks } = reportsLineChartData;
  const { t, i18n } = useTranslation();
  const app = useSelector((state) => state[APP_STATE]);

  const init = () => {
    FetchData("GET", `/app/req/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === "OK") {
        console.log(result);
      } else {
        Func.exitApp();
      }
    });
  };

  const setBtnBadge = (name, value, link) => {
    if (value > 0)
      return (
        <Grid item xs={12} md={6} lg={2}>
          <MDButton variant="gradient" color="info" size="large" href={link} fullWidth>
            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              {name}

              <MDBadge badgeContent={value} color="error" container size="xs" />
            </Box>
          </MDButton>
        </Grid>
      );

    return null;
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    // init();
  }, []);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.dashboard`), t(`menu.dashboard_sell`)]} />
      <MDBox py={3}>
        <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={2}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="dark"
                  icon="paid"
                  title="Bookings"
                  count={281}
                  percentage={{
                    color: "success",
                    amount: "+55%",
                    label: "than lask week",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="warning"
                  icon="weekend"
                  title="Bookings"
                  count={281}
                  percentage={{
                    color: "success",
                    amount: "+55%",
                    label: "than lask week",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  icon="leaderboard"
                  title="Users"
                  count="2,300"
                  percentage={{
                    color: "success",
                    amount: "+3%",
                    label: t(`authen.tels`),
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="success"
                  icon="store"
                  title="Revenue"
                  count="34k"
                  percentage={{
                    color: "success",
                    amount: "+1%",
                    label: "than yesterday",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="primary"
                  icon="person_add"
                  title="Followers"
                  count="+91"
                  percentage={{
                    color: "success",
                    amount: "",
                    label: "Just updated",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="error"
                  icon="point_of_sale"
                  title="Followers"
                  count="+91"
                  percentage={{
                    color: "success",
                    amount: "",
                    label: "Just updated",
                  }}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox>
          <Grid container spacing={3}>
            {setBtnBadge(
              t(`menu.bidding_appointment`),
              app.badge.get_offer,
              "/bidding_appointment_op"
            )}
            {setBtnBadge(
              t(`menu.bidding_appointment_ar`),
              app.badge.is_arrived,
              "/bidding_appointment_ar"
            )}
            {setBtnBadge(
              t(`menu.vehicle_buy_in_transaction`),
              app.badge.buyin_transaction,
              "/vehicle_buy_in_transaction_op"
            )}
            {setBtnBadge(
              t(`menu.vpark_transaction`),
              app.badge.vpark_transaction,
              "/vpark_transaction_op"
            )}
            {setBtnBadge(t(`menu.v_request`), app.badge.v_request, "/v_request_op")}
            {setBtnBadge(
              t(`menu.showroom_apointment`),
              app.badge.showroom_appointment,
              "/showroom_apointment_op"
            )}
            {setBtnBadge(t(`menu.wait_for_return`), app.badge.wait_for_return, "/wait_for_return")}
          </Grid>
        </MDBox>
        <MDBox mt={6}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="website views"
                  description="Last Campaign Performance"
                  date="campaign sent 2 days ago"
                  chart={reportsBarChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="daily sales"
                  description={
                    <>
                      (<strong>+15%</strong>) increase in today sales.
                    </>
                  }
                  date="updated 4 min ago"
                  chart={sales}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="dark"
                  title="completed tasks"
                  description="Last Campaign Performance"
                  date="just updated"
                  chart={tasks}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox mt={3}>
          <Grid container>
            <SalesByCountry />
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
